import { gql } from 'graphql-request';
import { request } from '@/utilities/graphQLClient';

import { QueryContext, QueryResponse } from './types';
import { COMPANY_NARRATIVE_FRAGMENT } from './fragment';

export const queryFn = async ({ queryKey: [_, slug] }: QueryContext) => {
  const { Narrative, errors } = await request<QueryResponse>(
    gql`
      query Narrative($slug: String!) {
        Narrative(slug: $slug) {
          id
          title
          author {
            id
            name
            role
            slug
            url
            imageUrl
          }
          contentBlocks {
            contentHtml
            title
          }
          companyId
          coverImageUrl
          publishedAt
          updatedAt
          status
          slug
          ...CompanyFields
          valuations {
            contentHtml
            fairValue
            sharePriceAtPublish
            valuationByLine
            type
          }
          currencyIso
          visibility
          userHoldsPosition
          disclaimer
          announcements {
            contentHtml
            createdAt
            id
          }
          voteCount {
            downvotes
            upvotes
          }
        }
      }
      ${COMPANY_NARRATIVE_FRAGMENT}
    `,
    { slug }
  );

  const keyTakeaways = Narrative.contentBlocks.find(
    (c) => c.title === 'Key Takeaways'
  );
  const blocks = Narrative.contentBlocks.filter(
    (c) => c.title !== 'Key Takeaways'
  );
  const baseCaseValuation = Narrative.valuations?.find(
    (v) => v.type === 'base'
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return {
    ...Narrative,
    keyTakeaways: keyTakeaways?.contentHtml,
    contentBlocks: blocks,
    baseCaseValuation,
  };
};
